export const classes = {
  tab: 'h-full',
};
